module.exports = __webpack_public_path__ + "img/4.547675b1.jpg";